module.exports = __webpack_public_path__ + "img/icon-sistema.4f166c5c.svg";